var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slice-page"},[(!_vm.isPortrait)?_c('img',{staticClass:"slice-bg",attrs:{"src":_vm.preText + _vm.bgPc}}):_c('img',{staticClass:"slice-bg",attrs:{"src":_vm.preText + _vm.bgMob}}),_c('Swiper1')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }